<mat-accordion>
  <mat-expansion-panel [(expanded)]="expanded" class="config-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>
        @if (bannersConfigForm.invalid && isSubmitted) {
          <mat-icon class="error-icon"
          matTooltip="Banners configuration contains errors">error</mat-icon>
        }
        <h3>Banners configuration</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="bannersConfigForm">
      <general-banners-configuration [bannersConfig]="bannersConfig"
      [parentFormGroup]="bannersConfigForm"></general-banners-configuration>
      <banners-list [bannersConfig]="bannersConfig" [sectionConfigId]="sectionConfigId"
      [parentFormGroup]="bannersConfigForm"></banners-list>
    </form>
  </mat-expansion-panel>
</mat-accordion>
